import React, { useCallback } from 'react';
import { View, StyleSheet } from 'react-native';
import { Button, Spacer, rem } from 'design-system';
const InsightsCategorySelector = ({ category, setCategory }) => {
    const handlePress = useCallback((type) => () => {
        setCategory(type);
    }, [setCategory]);
    const Btn = useCallback(({ title, type }) => {
        const properties = category === type ? { brandLight: true } : { grey: true };
        return (<Button square small {...properties} title={title} containerStyle={styles.btn} onPress={handlePress(type)}/>);
    }, [handlePress, category]);
    return (<View style={styles.row}>
      <Btn title="Sectors" type="SECTOR"/>
      <Spacer w={8}/>
      <Btn title="Holdings" type="HOLDINGS"/>
    </View>);
};
export default InsightsCategorySelector;
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        justifyContent: 'center',
    },
    btn: {
        paddingHorizontal: rem(16),
    },
});
